import Enums from '@/constants/Enums.js';
export const bytesInKB = 1024;
/**
 * Takes bytes as input
 * Depending upon the size
 * Resolve it to default size string
 *
 * @param {number} bytes
 * @param {string} returnType
 *
 * if returnType = object passed, response will be in object format
 * to get size & unit
 * else respone of function will be string type includes size & unit.
 */
export default function bytesToSize(bytes, returnType) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (!bytes) {
    return returnType === 'object' ? { size: 0, unit: 'Byte' } : '0 Byte';
  }
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(bytesInKB)));
  // to convert decimal points upto 2 digits and back to int type by adding '+' in starting
  const size = +(bytes / Math.pow(bytesInKB, i)).toFixed(Enums.numbers.two);
  if (returnType === 'object') {
    return {
      size,
      unit: sizes[i]
    };
  }
  return `${size} ${sizes[i]}`;
}
